import { render, staticRenderFns } from "./DialogSaveCampaignDraft.vue?vue&type=template&id=c6064fb6&"
import script from "./DialogSaveCampaignDraft.vue?vue&type=script&lang=js&"
export * from "./DialogSaveCampaignDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports